<template>
  <div>项目成员</div>
</template>

<script>
  export default {
    name: "project-member"
  }
</script>

<style scoped>

</style>
